import React, { createContext, useContext } from 'react'

import type { OrderItemsModule, OrderItemsModuleApi } from '../types'

const OrderItemsModuleContext = createContext<OrderItemsModuleApi | null>(null)

interface ProviderProps {
  module: OrderItemsModule<any, any>
  children: React.ReactNode
}

/**
 * Instância única do módulo. Fica aqui, e não na raiz do form, porque o módulo observa os itens:
 * na raiz, cada tecla digitada num item re-renderizaria o formulário inteiro.
 */
export const OrderItemsModuleProvider: React.FC<ProviderProps> = ({ module, children }) => {
  const api = module.useModule()
  return <OrderItemsModuleContext.Provider value={api}>{children}</OrderItemsModuleContext.Provider>
}

export const useOrderItemsModule = (): OrderItemsModuleApi => {
  const ctx = useContext(OrderItemsModuleContext)
  if (!ctx) throw new Error('useOrderItemsModule precisa de um OrderItemsModuleProvider acima na árvore')
  return ctx
}
